export default {
	SELECTION: 'selection',
	PROGRAM_ITEM_AD: 'programItemAd',
	PROGRAM_ITEM_SORT: 'programItemSort',
	PROGRAM_SORTING: 'programSorting',
	FLYER_ITEM_AD: 'flyerItemAd',
	SIGNAGE_ITEM_AD: 'signageItemAd',
	MULTISITE_SELECTOR: 'multisiteSelectorSorting',
	WEEK_PROGRAM_FLYER_DATE_ITEM: 'weekProgramFlyerDateItem',
	WEEK_PROGRAM_FLYER_ITEM_AD: 'weekProgramFlyerItemAd',
	WEEK_PROGRAM_FLYER_MOVIE_ITEM: 'weekProgramFlyerMovieItem',
	MOVIE_IMAGE: 'movieImage',
	NEWSPAPER_ITEM_ADD: 'newspaperItemAdd'
}